import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";
import EmployerService from "../../pages/members/Services/EmployerService";
import { diaryUrl, employerListUrl, unAuthorizedPageUrl, userLandingPageUrl } from "../../pages/members/Shared/Constants/AppConstant";
import { useAuth } from "../../providers/AuthProvider";
import { AdminLandingPage } from "./landingpages/AdminLandingPage";
import { HomePage } from "./landingpages/HomePage";

export const Home = () => {
    let auth = useAuth();
    const navigate = useNavigate();
    let isAuthenticated = auth?.isAuthenticated();
    let isGpDiaryAdmin = auth?.isGpDiaryAdmin();

    //Navigate to the home page if not authenticated
    if (!isAuthenticated) {
        return <HomePage login={login} />;
    }

    //Navigate to unauthorised if user other than admin, member and staff tries to login
    if (!auth?.isAuthorised()) {
        return <Navigate to={unAuthorizedPageUrl} replace />;
    }

    useEffect(() => {
        if (isAuthenticated && !isGpDiaryAdmin) {
            EmployerService.getEmployers().then((res) => {
                if (res.data && res.data.length > 0) {
                    let unArchievedEmployersList = res.data.filter((x: { isArchived: boolean; }) => x.isArchived == false);
                    if (unArchievedEmployersList.length > 0)
                        navigate(diaryUrl);
                    else
                        navigate(employerListUrl);
                } else {
                    navigate(userLandingPageUrl);
                }
            })
        }
    }, []);

    function login() {
        auth?.signinRedirect()
    }

    return (
        <div>
            {isAuthenticated && isGpDiaryAdmin ? (<AdminLandingPage />)
                : (<div className="loader-backdrop">
                    <Spinner animation="border" variant="primary" />
                </div>)
            }
        </div>
    );
}